// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Panel__section {
  padding: 16px;
  border: 1px solid var(--color-border-subdued);
  border-radius: 8px;
}
.n-Panel__section--variant-default {
  background: color-mix(in srgb, var(--color-background-layer-1), transparent 10%);
}
.n-Panel__section--variant-compact,
.n-Panel__section--variant-plain {
  background: transparent;
}
.n-Panel__section--variant-plain {
  padding: 0;
  border: 0;
}
.n-Panel__section-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: start;
  margin-bottom: 16px;
}
.n-Panel__section-heading {
  min-width: 0;
}
.n-Panel__section-title,
.n-Panel__section-description {
  margin: 0;
}
.n-Panel__section-header-end {
  min-width: 0;
}
.n-Panel__section-content {
  display: grid;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/panel/PanelSection.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,aAAA;EACA,6CAAA;EACA,kBAAA;AAQJ;AANI;EACE,gFAAA;AAQN;AALI;;EAEE,uBAAA;AAON;AAJI;EACE,UAAA;EACA,SAAA;AAMN;AAFE;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAIJ;AADE;EACE,YAAA;AAGJ;AAAE;;EAEE,SAAA;AAEJ;AACE;EACE,YAAA;AACJ;AAEE;EACE,aAAA;EACA,SAAA;AAAJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-Panel {\n  &__section {\n    padding: @layoutUnit-md;\n    border: 1px solid var(--color-border-subdued);\n    border-radius: @size--xxs;\n\n    &--variant-default {\n      background: color-mix(in srgb, var(--color-background-layer-1), transparent 10%);\n    }\n\n    &--variant-compact,\n    &--variant-plain {\n      background: transparent;\n    }\n\n    &--variant-plain {\n      padding: 0;\n      border: 0;\n    }\n  }\n\n  &__section-header {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: @layoutUnit-md;\n    align-items: start;\n    margin-bottom: @layoutUnit-md;\n  }\n\n  &__section-heading {\n    min-width: 0;\n  }\n\n  &__section-title,\n  &__section-description {\n    margin: 0;\n  }\n\n  &__section-header-end {\n    min-width: 0;\n  }\n\n  &__section-content {\n    display: grid;\n    gap: @layoutUnit-md;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
